<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div
        class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >
        
        
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="col-md-12">
        <div class="row">
          <!-- <form class="row" @submit.prevent="rechercher"> -->
            
            <!-- <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                 Mot clé
                </label>
                <Field 
                  style="max-height: 42px;"
                  v-model="searchTerm"
                  @keyup="rechercher" 
                  name="mot" 
                  type="text" 
                  aria-disabled="true"
                  class="form-control shadow-none fs-md-15 text-black" 
                  placeholder="Recherche par mot clé"/>
              </div>
            </div> -->
  
            <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Date Debut <span class="text-danger">*</span>
                </label>
                <Field name="dateDebut" type="date" v-model="_dateDebut"  :value="getCurrentDate()"
                class="form-control shadow-none fs-md-15 text-black"/>
                <ErrorMessage name="dateDebut" class="text-danger"/>
              </div>
            </div>
  
            <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Date Fin <span class="text-danger">*</span>
                </label>
                <Field name="dateFin" type="date"  v-model="_dateFin"  :value="getCurrentDate()"
                class="form-control shadow-none fs-md-15 text-black"/>
                <ErrorMessage name="dateFin" class="text-danger"/>
              </div>
            </div>

            <!-- <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Produit <span class="text-danger">*</span>
                </label>
                <Field v-model="_produit" name="produit" v-slot="{ field }">
                  <Multiselect
                    :options="produitOptions" 
                    :searchable="true"
                    v-model="field.value"
                    v-bind="field"
                    placeholder="Sélectionner un produit"
                  />
                </Field>
                <ErrorMessage name="produit" class="text-danger"/>
              </div>
            </div> -->

            
            <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Produit 
                </label>
                <Field v-model="_produit" name="produit" v-slot="{ field }">
                  <Multiselect
                    :options="
                    async (query) => {
                      const results = await searchProduit(query);
                      if (results && results.length > 0) {
                        return results;
                      } else if (query.length >= 3) {
                        return [
                          { value: '', label: 'Aucun enregistrement trouvé' },
                        ];
                      } else {
                        return [];
                      }
                    }"
                    noOptionsText="Tapez au moins deux caractères"
                    :filter-results="false" 
                    :min-chars="3" 
                    :delay="0"
                    :searchable="true"
                    v-model="field.value"
                    v-bind="field"
                    placeholder="Sélectionner un produit"
                  />
                </Field>
                <ErrorMessage name="produit" class="text-danger"/>
              </div>
            </div>

            <div class="col">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Categorie <span class="text-danger">*</span>
                </label>
                <Field v-model="_categorie" name="categorie" v-slot="{ field }">
                  <Multiselect
                    :options="categorieOptions"
                    :searchable="true"
                    v-model="field.value"
                    v-bind="field"
                    placeholder="Sélectionner une categorie"
                  />
                </Field>
                <ErrorMessage name="categorie" class="text-danger"/>
              </div>
            </div>
            
  
          <!-- </form> -->
        </div>
        </div>
        <hr>
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                  PRODUIT
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                  STOCK INITIAL
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                  QTE ENTREE
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                  QTE VENTE
                </th>
                <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0" >
                  STOCK FINAL
                </th>
                <th scope="col"  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                >Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(el, index) in elements" :key="index">
                <td class="shadow-none lh-1 fw-medium text-primary">
                  {{ el.nomComplet+' [ '+ el.conditionnement.code+' ]' }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ 
                    ((el.totalApprovisionnementInitial) ? el.totalApprovisionnementInitial : 0) -
                    ((el.totalVenduInitial) ? el.totalVenduInitial : 0)
                  }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-primary">
                  {{  (el.totalApprovisionnement) ? el.totalApprovisionnement : 0 }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                 {{ (el.totalVendu) ? el.totalVendu : 0 }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-primary">
                 {{  
                  ((el.totalApprovisionnementInitial) ? el.totalApprovisionnementInitial : 0) +
                  ((el.totalApprovisionnement) ? el.totalApprovisionnement : 0) -
                  ((el.totalVenduInitial) ? el.totalVenduInitial : 0) -
                  ((el.totalVendu) ? el.totalVendu : 0)

                }}
                </td>
                <td
                class="shadow-none lh-1 fw-medium text-end pe-0 sm"
                >
                <div class="dropdown">
                    <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                        Actions 
                        <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                    </span>
                    <ul class="dropdown-menu">
                      <li>
                            <router-link :to="{ name: 'FicheProduitPage', params: { id: el.id } }" 
                                        class="dropdown-item d-flex align-items-center">
                                <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>
                                Fiche de stock
                            </router-link>
                            <!-- <a href="javascript:;" style="text-decoration: none;"
                            @click="ficheProduit(el.produit.id)"
                            
                            > 
                              Fiche de stock
                            </a> -->
                        </li>
                        <!-- <li>
                            <router-link :to="{ name: 'ViewAbonnementPage', params: { id: abonne.id } }" 
                                        class="dropdown-item d-flex align-items-center">
                                <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>
                                Détails
                            </router-link>
                        </li> -->
                        <!-- <li v-if="abonne.etat == 'En attente' && checkPermission('ValidAbonnement')">
                            <router-link :to="{ name: 'ViewAbonnementPage', params: { id: abonne.id } }" class="dropdown-item d-flex align-items-center">
                                <i class="flaticon-check lh-1 me-8 position-relative top-1"></i>Valider l'abonnement
                            </router-link>
                        </li> -->
                    </ul>
                </div>
                </td>
              </tr>
              <!-- <tr>
                <td colspan="6" class="text-end"> Total : </td>
                <td> <h5> <b>{{ formatMontant(total) }}</b></h5>  </td>
              </tr> -->
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
        </div>
      </div>
    </div>
  
  </template>
  
  <script lang="ts">
  import { defineComponent, onMounted, ref, watch } from "vue";
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import ApiService from "@/services/ApiService";
  import { useRouter } from 'vue-router';
  import { format_date,suppression,format_Date, hideModal, showModal,separateur, error,success, getCurrentDate } from "@/utils/utils";
  import PaginationComponent from '@/components/Utilities/Pagination.vue';
  import JwtService from "@/services/JwtService";
  import Multiselect from '@vueform/multiselect';
  import axios from "axios";
  import { Reglement } from '../../models/Reglement';
  
  export default defineComponent({
      name: "MouvementDuStock",
      components: {
        // Form,
        Field,
        Multiselect,
        PaginationComponent,
    },
    setup: () => {
  
      const elements = ref<Array<any>>([]);
      const elementsAppro = ref<Array<any>>([]);
      const elementsVente = ref<Array<any>>([]);
      const reglement = ref<Reglement>();
      const ResiliationRef = ref<null | HTMLElement>(null);
      const modeleOptions = ref([]);
      const agentOptions = ref([]);
      const clientOptions = ref([]);
      const venteOptions = ref([]);
      const categorieAbonneOptions = ref([]);
      const total = ref(0);
      const _produit = ref('');
      const _categorie = ref('');
      const categorieOptions = ref([]);
  

  
      // BEGIN PAGINATE
      const _dateDebut = ref(null);
      const _dateFin = ref(null);
      const _agent = ref('');
      const _client = ref('');
      const _vente = ref('');
      const searchTerm = ref('');
      const page = ref(1);
      const totalPages = ref(0);
      const limit = ref(10);
      const totalElements = ref(0);
      const router = useRouter();
  
      const handlePaginate = ({ page_, limit_ }) => {
        try {
          page.value = page_;
          getAll(page_, limit_);
        } catch (error) {
          //
        }
      };
     
  
      watch([_dateDebut, _dateFin, _agent, _client, _vente, searchTerm], () => {
        console.log('watching', _dateDebut, _dateFin, _agent);
        rechercher();
      });

    
  
      function rechercher(){
        getAll(page.value, limit.value, searchTerm.value, _produit.value ?? undefined, _dateDebut.value ?? undefined, _dateFin.value ?? undefined, _categorie.value ?? undefined);
      }
  
      // END PAGINATE
      const resiliation = (id: number) => {
        //show modal
        showModal(ResiliationRef.value!);
      }

      const ficheProduit = (id: number) => {
        ApiService.get("/fiche/produit/"+id)
            .then(({ data }) => {
              console.log("id produit", id);
              console.log("data deschanel", data);
            })
            .catch(({ response }) => {
            // produitsError.value = true;
            });
      }

  
      

      const fetchClient = async () => {
        ApiService.get("/clients")
            .then(({ data }) => {
            clientOptions.value = data.data.data.map((p) => {
              return {
                value: p.id,
                label: "[ "+ p.code +" ] " +p.nom + " " + p.prenoms,
              };
            });
            console.log('clients', clientOptions.value);
            })
            .catch(({ response }) => {
            // produitsError.value = true;
            });
      };

      const fetchCategorie = async () => {
        ApiService.get("/categories")
            .then(({ data }) => {
              // console.log('categories', data.data.data);
              categorieOptions.value = data.data.data.map((p) => {
              return {
                value: p.id,
                label: p.code + " " + p.libelle,
              };
            });
              console.log('clients', categorieOptions.value);
            })
            .catch(({ response }) => {
            // produitsError.value = true;
            });
      };

      const fetchVente = async () => {
        ApiService.get("/ventes")
            .then(({ data }) => {
            venteOptions.value = data.data.data.map((p) => {
              return {
                value: p.id,
                label: p.client.code+" - "+p.montant,
              };
            });
            console.log('clients', venteOptions.value);
            })
            .catch(({ response }) => {
            // produitsError.value = true;
            });
      };

      const searchProduit = async (key) => {
        try {
          const  data  = await ApiService.get("/produit/recherche/" + key);
          clientOptions.value = data.data.data.map((p) => ({
            value: p.id,
            label: "[ " + p.code + " ] " + p.libelle,
          }));
          console.log("clients", clientOptions.value);
          return clientOptions.value;
        } catch (error) {
          return [];
        }
      };
  
      function getAll(page = 1, limi = 10, searchTerm = '', _produit = '', _dateDebut = '' , _dateFin = '', _categorie = '') {
        console.log('fetching reglements', _agent, _client, _vente);
        return ApiService.get(`/mouvement/stock?page=${page}&limit=${limi}&mot=${searchTerm}&produit=${_produit}&dateDebut=${_dateDebut}&dateFin=${_dateFin}&categorie=${_categorie}&ok`)
          .then(({ data }) => {
            console.log('data', data);
            elements.value = data.data.data;
            // elementsAppro.value = data.data.totalApprovisionnement;
            // elementsVente.value = data.data.totalVendu;
            totalPages.value = data.data.totalPages;
            limit.value = data.data.limit;
            totalElements.value = data.data.totalElements;
            console.log('elements', totalPages.value, limit.value, totalElements.value);
            // total.value = reglements.value.reduce((acc,p) => {
            //   const mt = p.montant !== null && !isNaN(p.montant) ? parseFloat(p.montant.toString()) : 0;
            //   return acc + mt;
            // }, 0)
          })
          .catch(({ response }) => {
            // error(response.data.message);
          });
      }
  
      onMounted(async () => {
          await fetchClient();
          await fetchVente();
          await getAll();
          await fetchCategorie();
      });
  
    

    const formatMontant = (montant) => {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(montant);
    };
      
      return { 
        ficheProduit,
        elements,
        elementsAppro,
        elementsVente,
        // checkPermission,
        modeleOptions,
        agentOptions,
        clientOptions,
        venteOptions,
        categorieAbonneOptions,
        format_date,
        suppression,
        getAll,
        resiliation,
        // resilier,
        page, 
        totalPages,
        limit,
        format_Date,
        totalElements,
        handlePaginate,
        separateur,
        searchTerm,
        rechercher,
        Multiselect,
        getCurrentDate,
        _dateDebut,
        _dateFin,
        _agent,
        _client,
        _vente,
        total,
        formatMontant,
        searchProduit,
        _produit,
        _categorie,
        categorieOptions,
        fetchCategorie,
        // valideAbonnement,
        // addValidAbonnementModalRef
      };
    },
  });
  </script>
  
  